const modal = {
	el: {
		win: $(window),
		doc: $(document),
		body: $('body'),
		modal: $('.modal'),
		modalBtnClose: $('.js-modal-close'),
		modalImage: $('.modal__image')
	},

	events() {

		if(!this.el.modal.length) return

		this.el.modal.hide()

		this.el.win.on('load', () => {
			this.el.body.css('overflow', 'hidden')
			this.el.modal.fadeIn()

			/*setTimeout(() => {
				this.el.body.removeAttr('style')
				this.el.modal.fadeOut()
			}, 30000);*/


		})

		this.el.modalBtnClose.on('click', () => {
			this.el.body.removeAttr('style')
			this.el.modal.fadeOut()
		})

		this.el.doc.on('click', e => {
			!$(e.target).closest('.modal__wrap').length ? (this.el.body.removeAttr('style'),
				this.el.modal.fadeOut()) : ''
		})


	},

	init() {
		this.events()
	}
}

modal.init()
